/**
 * CSS 클래스명을 안전하게 결합하는 유틸리티
 * falsy 값(undefined, false, null, '', 0, 0n)을 자동으로 필터링
 *
 * @example
 * combineClasses('btn', isActive && 'active', undefined, 'large')
 * // => 'btn active large'
 */
export const combineClasses = (
  ...classes: (string | undefined | false | null | 0 | 0n)[]
): string => {
  return classes.filter(Boolean).join(' ');
};
